module.exports = __webpack_public_path__ + "img/powered-by-dark.6f7fdbcb.svg";